<div
  class="alert d-flex align-items-start gap-2"
  [ngClass]="['alert-' + variant, extraClass]"
  role="alert"
>
  <div class="flex-grow-1" #body>
    <ng-container *ngIf="message != null && message !== ''; else projectedContent">{{ message }}</ng-container>
    <ng-template #projectedContent><ng-content></ng-content></ng-template>
  </div>
  <button
    type="button"
    bkButton kind="text" class="p-0 flex-shrink-0 copyable-message-btn"
    [class.text-danger]="variant === 'danger'"
    [class.text-warning]="variant === 'warning'"
    [attr.aria-label]="copied ? 'Copied' : 'Copy message'"
    [title]="copied ? 'Copied' : 'Copy message'"
    (click)="copy($event)"
  >
    <span class="material-icons" aria-hidden="true">{{ copied ? 'check' : 'content_copy' }}</span>
  </button>
</div>
